import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import heroVideo from "../../../assets/video/HeroVideo.mp4";

const fadeUp = (delay = 0) => ({
  initial: { opacity: 0, y: 30 },
  animate: { opacity: 1, y: 0 },
  transition: { duration: 0.6, delay },
});

export default function HeroSection() {
  return (
    <section className="relative min-h-[85vh] sm:min-h-screen bg-gradient-to-br from-[#053676] via-[#2A71E8] to-[#181059] overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-72 h-72 bg-white rounded-full blur-3xl" />
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#BE2117] rounded-full blur-3xl" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col lg:flex-row items-center justify-between py-16 sm:py-20 lg:py-0 lg:min-h-screen">
        <div className="flex-1 text-center lg:text-left max-w-2xl">
          <motion.span
            {...fadeUp(0.1)}
            className="inline-block bg-white/20 text-white px-5 py-1.5 rounded-[25px] text-sm font-sans font-medium mb-6"
          >
            Digital Sign Language Interpreter
          </motion.span>

          <motion.h1
            {...fadeUp(0.2)}
            className="text-white font-sans font-bold text-4xl sm:text-5xl lg:text-6xl leading-tight welcomeScreenTextShadow"
          >
            Breaking{" "}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-white to-blue-200">
              Communication
            </span>{" "}
            Barriers
          </motion.h1>

          <motion.p
            {...fadeUp(0.35)}
            className="text-white/90 font-sans font-medium text-lg sm:text-xl mt-6 leading-relaxed"
          >
            Translating Sign Language to Speech and Text, and vice versa — all
            in real-time. Making communication accessible for everyone.
          </motion.p>

          <motion.div
            {...fadeUp(0.5)}
            className="flex flex-col sm:flex-row gap-4 mt-8 justify-center lg:justify-start"
          >
            <Link
              to="/register"
              className="bg-white text-[#2A71E8] font-sans font-bold px-8 py-3 rounded-[20px] text-lg hover:bg-blue-50 transition-colors text-center"
            >
              Get Started
            </Link>
            <Link
              to="/login"
              className="border-2 border-white text-white font-sans font-bold px-8 py-3 rounded-[20px] text-lg hover:bg-white/10 transition-colors text-center"
            >
              Log In
            </Link>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.3 }}
          className="flex-1 flex justify-center items-center mt-12 lg:mt-0"
        >
          <div className="w-[300px] h-[400px] sm:w-[400px] sm:h-[500px] lg:w-[500px] lg:h-[600px] rounded-[30px] overflow-hidden shadow-2xl">
            <video
              src={heroVideo}
              autoPlay
              loop
              muted
              playsInline
              className="w-full h-full object-contain"
            />
          </div>
        </motion.div>
      </div>

      <motion.div
        animate={{ y: [0, 8, 0] }}
        transition={{ duration: 1.5, repeat: Infinity }}
        className="absolute bottom-6 left-1/2 -translate-x-1/2 hidden sm:block"
      >
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center pt-2">
          <div className="w-1.5 h-3 bg-white/70 rounded-full" />
        </div>
      </motion.div>
    </section>
  );
}
